import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/shareCodeMissingModal.scss';
import ButtonComponent from './ButtonComponent';
import Popup from './Popup';
import { t } from 'i18next';
import { getImageSrc } from '../helper/imageBlobCache';
// Shown when the share code in the URL resolves to nothing. Purely
// informational — one dismiss button, no destructive choice — so it follows
// SaveEditsReminderModal's layout with a single action.
//
// The wording is composed from the two halves of `notice`, because a single
// sentence cannot be true for every case:
//
//   reason   - WHY it failed, and what the user can do about it. "No such code"
//              and "sign in first" need completely different advice; the app
//              used to collapse every failure into the former.
//   fallback - WHAT is on the canvas behind this dialog. Claiming "a blank
//              workspace" when the activity's own starting state was loaded
//              would contradict what the user can see.
var TITLE_KEY = {
    notFound: 'text.shareCodeNotFoundTitle',
    unauthorized: 'text.shareCodeSignInTitle',
    error: 'text.shareCodeErrorTitle',
};
var REASON_KEY = {
    notFound: 'text.shareCodeNotFoundReason',
    unauthorized: 'text.shareCodeSignInReason',
    error: 'text.shareCodeErrorReason',
};
var FALLBACK_KEY = {
    blank: 'text.shareCodeFallbackBlank',
    activityDefault: 'text.shareCodeFallbackActivityDefault',
};
var ShareCodeMissingModal = function (_a) {
    var showModal = _a.showModal, closeModal = _a.closeModal, notice = _a.notice;
    return (_jsx(Popup, { isOpen: showModal, onClose: closeModal, ariaLabelledBy: "scmm-title", children: _jsx("div", { className: "scmm-container", children: _jsxs("div", { className: "scmm-content", children: [_jsx("h1", { id: "scmm-title", className: "scmm-title", children: t(TITLE_KEY[notice.reason]) }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsxs("div", { className: "scmm-body", children: [t(REASON_KEY[notice.reason]), " ", t(FALLBACK_KEY[notice.fallback])] }), _jsx("div", { className: "scmm-buttons", children: _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "scmm-btn scmm-okBtn", normalCSS: "scmm-okBtn", clickHandler: closeModal }) }), _jsx("div", { className: "scmm-footer", children: _jsx("img", { src: getImageSrc('./assets/images/popupColorPatch.svg'), tabIndex: -1, alt: "" }) })] }) }) }));
};
export default ShareCodeMissingModal;
